import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

/** SCRUM-253: keeps the real-estate list and the map in sync. */
export interface MapHover { id: number | null; source: 'list' | 'map'; }
export interface MapCamera {
  center: [number, number];
  zoom: number;
  /** The results URL the camera belongs to (filters live in the URL / storage). */
  url: string;
  /** The ad whose preview card was open. */
  selectedId: number | null;
  /** Phone: the map (not the list) was showing. */
  mobileMapOpen: boolean;
}

@Injectable({providedIn: 'root'})
export class NadlanMapService {
  /** True while a map is shown next to / over the list. */
  active = false;
  readonly hover$ = new BehaviorSubject<MapHover>({id: null, source: 'list'});
  /** "הצג במפה" on a card: centre the map on that ad and open its preview. */
  readonly focus$ = new Subject<number>();
  /** Where the map was when the user left the page (e.g. opened an ad), so
   *  "back" returns to the same spot with the same preview open. */
  lastCamera: MapCamera | null = null;
  /** "חיפוש באזור זה" area that was active on that page. */
  lastArea: { url: string; bbox: string } | null = null;

  /** Saved camera for this results page, or null. */
  cameraFor(url: string): MapCamera | null {
    return this.lastCamera && this.lastCamera.url === url ? this.lastCamera : null;
  }

  get hoveredId(): number | null { return this.hover$.value.id; }

  hover(id: number | null, source: 'list' | 'map'): void {
    if (this.hover$.value.id === id && this.hover$.value.source === source) return;
    this.hover$.next({id, source});
  }

  focus(id: number): void { this.focus$.next(id); }
}
